import React from 'react'



import Terms from "./termAndPolicy/Terms"
const Term = () => {
  return (
    <>
      <Terms />
    </>
  )
}

export default Term